// import React, { useState } from "react";
// import { Filter, Calendar, X, ArrowLeft } from "lucide-react";
// import { motion, AnimatePresence } from "framer-motion";
// import moment from "moment";
// import { useNavigate } from "react-router-dom";

// export default function TopHeader({ loadTransaction }) {
//   const navigate = useNavigate();

//   const [showFilter, setShowFilter] = useState(false);
//   const [showCustom, setShowCustom] = useState(false);
//   const [customRange, setCustomRange] = useState({ start: "", end: "" });

//   const filters = [
//     "Today",
//     "Last Week",
//     "Last Month",
//     "Last 3 Months",
//     "Last 6 Months",
//     "Last Year",
//     "Custom",
//   ];

//   const handleFilterSelect = (item) => {
//     let start, end;
//     switch (item) {
//       case "Today":
//         start = moment().startOf("day");
//         end = moment().endOf("day");
//         break;
//       case "Last Week":
//         start = moment().subtract(1, "week").startOf("week");
//         end = moment().subtract(1, "week").endOf("week");
//         break;
//       case "Last Month":
//         start = moment().subtract(1, "month").startOf("month");
//         end = moment().subtract(1, "month").endOf("month");
//         break;
//       case "Last 3 Months":
//         start = moment().subtract(3, "months").startOf("month");
//         end = moment().endOf("month");
//         break;
//       case "Last 6 Months":
//         start = moment().subtract(6, "months").startOf("month");
//         end = moment().endOf("month");
//         break;
//       case "Last Year":
//         start = moment().subtract(1, "year").startOf("year");
//         end = moment().subtract(1, "year").endOf("year");
//         break;
//       case "Custom":
//         setShowCustom(true);
//         return;
//       default:
//         return;
//     }

//     loadTransaction(start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD"));
//     setShowFilter(false);
//   };

//   const handleCustomSubmit = () => {
//     if (!customRange.start || !customRange.end) return;
//     loadTransaction(customRange.start, customRange.end);
//     setShowCustom(false);
//     setShowFilter(false);
//   };

//   return (
//     <>
//       {/* 🔝 Header */}
//       <div className="flex justify-between items-center px-5 py-3 border-b-2 border-[var(--hover)] bg-[var(--background)] shadow-sm">
//         <button
//           onClick={() => navigate(-1)}
//           className="p-2 rounded-lg border-2 border-[var(--hover)] transition"
//         >
//           <ArrowLeft className="w-5 h-5 text-[var(--subtext)]" />
//         </button>

//         <div className="text-[var(--text)] font-semibold text-base select-none">
//           Transaction History
//         </div>

//         <button
//           onClick={() => setShowFilter(true)}
//           className="p-2 rounded-lg border-2 border-[var(--hover)] transition relative"
//         >
//           <Filter className="w-5 h-5 text-[var(--subtext)]" />
//           <span className="absolute top-1 right-1 w-2 h-2 bg-[var(--primary)] rounded-full"></span>
//         </button>
//       </div>

//      {/* 🧭 Filter Modal */}
//       <AnimatePresence>
//         {showFilter && (
//           <>
//             <motion.div
//               className="fixed inset-0 bg-black/40 backdrop-[var(--background)] z-40"
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               exit={{ opacity: 0 }}
//               onClick={() => setShowFilter(false)}
//             />
//             <motion.div
//               className="fixed bottom-0 left-0 right-0 z-50 border-t-2 border-t-[var(--hover)] bg-[var(--background)] rounded-t-3xl shadow-xl p-6 max-w-md mx-auto"
//               initial={{ y: "100%" }}
//               animate={{ y: 0 }}
//               exit={{ y: "100%" }}
//               transition={{ duration: 0.25, ease: "easeOut" }}
//             >
//               <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-base font-semibold text-[var(--text)] flex items-center gap-2">
//                   <Filter className="w-4 h-4 text-[var(--primary)]" /> Filter by
//                   Date
//                 </h2>
//                 <button
//                   onClick={() => setShowFilter(false)}
//                   className="p-1 rounded-full"
//                 >
//                   <X className="w-4 h-4 text-[var(--subtext)]" />
//                 </button>
//               </div>

//               <motion.div
//                 className="grid  grid-cols-2 gap-3"
//                 initial="hidden"
//                 animate="visible"
//                 variants={{
//                   visible: {
//                     transition: {
//                       staggerChildren: 0.05,
//                     },
//                   },
//                 }}
//               >
//                 {filters.map((item, i) => (
//                   <motion.button
//                     key={item}
//                     onClick={() => handleFilterSelect(item)}
//                     className="px-3 py-2 text-sm rounded-lg border-2 border-[var(--hover)] bg-[var(--background)] text-[var(--text)] transition shadow-sm"
//                     variants={{
//                       hidden: { opacity: 0, y: 10 },
//                       visible: { opacity: 1, y: 0 },
//                     }}
//                   >
//                     {item}
//                   </motion.button>
//                 ))}
//               </motion.div>
//             </motion.div>
//           </>
//         )}
//       </AnimatePresence>

//       {/* 📅 Custom Range */}
//       <AnimatePresence>
//         {showCustom && (
//           <>
//             <motion.div
//               className="fixed inset-0 bg-black/40 backdrop-[var(--background)]-sm z-40"
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               exit={{ opacity: 0 }}
//               onClick={() => setShowCustom(false)}
//             />
//             <motion.div
//               className="fixed bottom-0 left-0 right-0 z-50 bg-[var(--background)] rounded-2xl shadow-lg p-6 max-w-md mx-auto"
//               initial={{ y: "100%" }}
//               animate={{ y: 0 }}
//               exit={{ y: "100%" }}
//               transition={{ duration: 0.2 }}
//             >
//               <div className="flex justify-between items-center mb-3">
//                 <h2 className="text-base font-semibold text-[var(--text)] flex items-center gap-2">
//                   <Calendar className="w-4 h-4 text-[var(--primary)]" /> Custom
//                   Range
//                 </h2>
//                 <button
//                   onClick={() => setShowCustom(false)}
//                   className="p-1 hover:bg-[var(--hover)] rounded-full"
//                 >
//                   <X className="w-4 h-4 text-[var(--subtext)]" />
//                 </button>
//               </div>

//               <div className="space-y-3">
//                 <div>
//                   <label className="text-xs text-[var(--subtext)] mb-1 block">
//                     Start Date
//                   </label>
//                   <input
//                     type="date"
//                     max={new Date().toISOString().split("T")[0]}
//                     value={customRange.start}
//                     onChange={(e) =>
//                       setCustomRange({ ...customRange, start: e.target.value })
//                     }
//                     className="w-full bg-[var(--background)] px-3 py-2 border-2 rounded-lg bg-transparent text-[var(--text)] border-[var(--hover)] focus:ring-2 focus:ring-[var(--primary)] outline-none"
//                   />
//                 </div>

//                 <div>
//                   <label className="text-xs text-[var(--subtext)] mb-1 block">
//                     End Date
//                   </label>
//                   <input
//                     type="date"
//                     max={new Date().toISOString().split("T")[0]}
//                     value={customRange.end}
//                     onChange={(e) =>
//                       setCustomRange({ ...customRange, end: e.target.value })
//                     }
//                     className="w-full px-3 py-2 border-2 bg-[var(--background)] rounded-lg bg-transparent text-[var(--text)] border-[var(--hover)] focus:ring-2 focus:ring-[var(--primary)] outline-none"
//                   />
//                 </div>

//                 <button
//                   onClick={handleCustomSubmit}
//                   className="w-full bg-[var(--primary)] text-white py-2 rounded-lg font-medium text-sm hover:opacity-90 transition"
//                 >
//                   Apply Filter
//                 </button>
//               </div>
//             </motion.div>
//           </>
//         )}
//       </AnimatePresence>
//     </>
//   );
// }

import React, { useState } from "react";
import { Filter, ArrowUpDown, X, Calendar, Check } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import moment from "moment";

// Pass the currently active sortBy state to highlight it
export default function TopHeader({ onSort, reload, sortBy }) {
  const [showFilter, setShowFilter] = useState(false);
  const [showSort, setShowSort] = useState(false);
  const [showCustom, setShowCustom] = useState(false);
  const [customRange, setCustomRange] = useState({ start: "", end: "" });
  const [activeFilter, setActiveFilter] = useState("This Week"); // Added state for active filter

  // --- Configuration Data ---
  const filters = [
    "Today",
    "Yesterday", // Added Yesterday for completeness
    "This Week",
    "Last Week",
    "This Month",
    "Last Month",
    "Last 3 Months",
    "Custom",
  ];

  const sortOptions = [
    { label: "All (Default)", value: "all" },
    { label: "Deposit", value: "payment_id" },
    { label: "Withdrawal", value: "withdrawal_id" },
    { label: "Processing", value: "processing" },
    { label: "Successful", value: "successful" },
    { label: "Rejected", value: "rejected" },
  ];

  // --- Handlers ---
  const handleFilterSelect = (item) => {
    let start, end;

    // Set active filter state immediately
    setActiveFilter(item);

    switch (item) {
      case "Today":
        start = moment().startOf("day");
        end = moment().endOf("day");
        break;
      case "Yesterday":
        start = moment().subtract(1, "day").startOf("day");
        end = moment().subtract(1, "day").endOf("day");
        break;
      case "This Week":
        start = moment().startOf("week");
        end = moment().endOf("week");
        break;
      case "Last Week":
        start = moment().subtract(1, "week").startOf("week");
        end = moment().subtract(1, "week").endOf("week");
        break;
      case "This Month":
        start = moment().startOf("month");
        end = moment().endOf("month");
        break;
      case "Last Month":
        start = moment().subtract(1, "month").startOf("month");
        end = moment().subtract(1, "month").endOf("month");
        break;
      case "Last 3 Months":
        // Calculates 3 months ago from today, then uses the start of that month
        start = moment().subtract(3, "months").startOf("month");
        end = moment().endOf("day");
        break;
      case "Custom":
        setShowCustom(true);
        setShowFilter(false);
        return; // Don't close filter yet, wait for custom submit
      default:
        return;
    }

    // Call reload with YYYY-MM-DD format as required by the backend
    reload(start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD"));
    setShowFilter(false);
  };

  const handleCustomSubmit = () => {
    if (!customRange.start || !customRange.end) {
      // Optional: show a toast error here
      return;
    }
    setActiveFilter(`Custom: ${customRange.start} to ${customRange.end}`);
    reload(customRange.start, customRange.end);
    setShowCustom(false);
    setShowFilter(false);
  };

  const handleSortSelect = (value) => {
    onSort?.(value);
    setShowSort(false);
  };

  // --- Rendering ---
  return (
    <>
      {/* 🔝 Header Bar */}
      <div className="flex justify-between items-center px-4 py-3 border-b-2 border-[var(--hover)] bg-[var(--background)]">
        <button
          onClick={() => setShowSort(true)}
          className="p-2 rounded-full border-2 border-[var(--hover)] bg-[var(--hover)]/30 transition hover:bg-[var(--hover)]"
        >
          <ArrowUpDown className="w-5 h-5 text-[var(--text)]" />
        </button>

        <div className="text-[var(--text)] font-semibold text-base select-none flex flex-col items-center">
          Transaction History
          <span className="text-[10px] text-[var(--subtext)] font-medium opacity-80 mt-[2px]">
            {activeFilter}
          </span>
        </div>

        <button
          onClick={() => setShowFilter(true)}
          className="p-2 rounded-full border-2 border-[var(--hover)] bg-[var(--hover)]/30 transition hover:bg-[var(--hover)]"
        >
          <Filter className="w-5 h-5 text-[var(--text)]" />
        </button>
      </div>

      {/* 🧭 Filter Modal (Z-INDEX: 50) */}
      <AnimatePresence>
        {showFilter && (
          <>
            <motion.div
              className="fixed inset-0 bg-black/40 backdrop-blur-sm z-45"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setShowFilter(false)}
            />
            <motion.div
              className="fixed bottom-0 left-0 right-0 z-50 border-t-2 border-t-[var(--hover)] bg-[var(--background)] rounded-t-3xl shadow-xl p-6 max-w-md mx-auto"
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ duration: 0.25, ease: "easeOut" }}
            >
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-bold text-[var(--text)] flex items-center gap-2">
                  <Filter className="w-5 h-5 text-[var(--primary)]" /> Filter
                </h2>
                <button
                  onClick={() => setShowFilter(false)}
                  className="p-2 rounded-full hover:bg-[var(--hover)]"
                >
                  <X className="w-5 h-5 text-[var(--subtext)]" />
                </button>
              </div>

              <motion.div className="grid grid-cols-2 gap-3">
                {filters.map((item) => (
                  <button
                    key={item}
                    onClick={() => handleFilterSelect(item)}
                    className={`
                        px-3 py-2 text-sm rounded-lg border-2 transition shadow-sm font-medium flex justify-center items-center gap-2
                        ${
                          item === activeFilter
                            ? "border-[var(--primary)] bg-[var(--primary)] text-white"
                            : "border-[var(--hover)] bg-[var(--background)] text-[var(--text)] hover:border-[var(--primary)]"
                        }`}
                  >
                    {item}
                    {item === activeFilter && <Check className="w-4 h-4" />}
                  </button>
                ))}
              </motion.div>
            </motion.div>
          </>
        )}
      </AnimatePresence>

      {/* 🧩 Sort Modal (Z-INDEX: 50) */}
      <AnimatePresence>
        {showSort && (
          <>
            <motion.div
              className="fixed inset-0 bg-black/40 backdrop-blur-sm z-45"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setShowSort(false)}
            />
            <motion.div
              className="fixed bottom-0 left-0 right-0 border-t-2 border-t-[var(--hover)] z-50 bg-[var(--background)] rounded-t-3xl shadow-lg p-6 max-w-md mx-auto"
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ duration: 0.2 }}
            >
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-bold text-[var(--text)] flex items-center gap-2">
                  <ArrowUpDown className="w-5 h-5 text-[var(--primary)]" /> Sort
                  Trades
                </h2>
                <button
                  onClick={() => setShowSort(false)}
                  className="p-2 rounded-full hover:bg-[var(--hover)]"
                >
                  <X className="w-5 h-5 text-[var(--subtext)]" />
                </button>
              </div>

              <div className="space-y-2">
                {sortOptions.map((opt) => (
                  <button
                    key={opt.value}
                    onClick={() => handleSortSelect(opt.value)}
                    className={`
                        w-full px-3 py-3 text-sm rounded-lg border-2 transition shadow-sm text-left font-medium flex justify-between items-center
                        ${
                          opt.value === sortBy
                            ? "border-[var(--primary)] bg-[var(--primary)] text-white"
                            : "border-[var(--hover)] bg-[var(--background)] text-[var(--text)] hover:border-[var(--primary)]"
                        }`}
                  >
                    {opt.label}
                    {opt.value === sortBy && <Check className="w-4 h-4" />}
                  </button>
                ))}
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>

      {/* 📅 Custom Range Modal (Z-INDEX: 55) - Must be higher than Filter */}
      <AnimatePresence>
        {showCustom && (
          <>
            <motion.div
              className="fixed inset-0 bg-black/50 backdrop-blur z-54" // Higher backdrop z-index
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setShowCustom(false)}
            />
            <motion.div
              className="fixed bottom-0 left-0 right-0 z-55 bg-[var(--background)] rounded-t-3xl shadow-lg p-6 max-w-md mx-auto border-t-2 border-t-[var(--primary)]"
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ duration: 0.2 }}
            >
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-bold text-[var(--text)] flex items-center gap-2">
                  <Calendar className="w-5 h-5 text-[var(--primary)]" /> Custom
                  Range
                </h2>
                <button
                  onClick={() => setShowCustom(false)}
                  className="p-2 rounded-full hover:bg-[var(--hover)]"
                >
                  <X className="w-5 h-5 text-[var(--subtext)]" />
                </button>
              </div>

              <div className="space-y-4 mb-9 pb-9">
                {/* Input Fields */}
                <div>
                  <label className="text-xs text-[var(--subtext)] mb-1 block font-medium">
                    Start Date
                  </label>
                  <input
                    type="date"
                    max={moment().format("YYYY-MM-DD")} // Max date is today
                    value={customRange.start}
                    onChange={(e) =>
                      setCustomRange({ ...customRange, start: e.target.value })
                    }
                    className="w-full px-4 py-3 border-2 rounded-lg bg-transparent text-[var(--text)] border-[var(--hover)] focus:ring-2 focus:ring-[var(--primary)] focus:border-[var(--primary)] outline-none transition"
                  />
                </div>

                <div>
                  <label className="text-xs text-[var(--subtext)] mb-1 block font-medium">
                    End Date
                  </label>
                  <input
                    type="date"
                    max={moment().format("YYYY-MM-DD")} // Max date is today
                    value={customRange.end}
                    onChange={(e) =>
                      setCustomRange({ ...customRange, end: e.target.value })
                    }
                    className="w-full px-4 py-3 border-2 rounded-lg bg-transparent text-[var(--text)] border-[var(--hover)] focus:ring-2 focus:ring-[var(--primary)] focus:border-[var(--primary)] outline-none transition"
                  />
                </div>

                <button
                  onClick={handleCustomSubmit}
                  disabled={!customRange.start || !customRange.end}
                  className="w-full bg-[var(--primary)] text-white py-3 rounded-lg font-bold text-base transition disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Apply Filter
                </button>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
}
